import { Box, Stack } from "@mui/material";
import QRcode from "assets/images/tca/5/QRcodeFU05SelfManagementSkillsReview.png";
import { useRef } from "react";
import ReactToPrint from "react-to-print";

import VideoBlock from "../VideoBlock";
import YmcaPageHeader from "../YmcaPageHeader";

const StageFollowup05 = ({ sendContractToBackend }) => {
  const printTemplateRef = useRef();

  return (
    <>
      <Box className="greenContainer">
        <Box className="containerPadding">
          <Stack>
            <Box className="header1" mb={"20px"}>
              Follow Up Appointment 5
            </Box>
            <Box className="header2 green" mb={"16px"}>
              SELF-MANAGEMENT SKILLS REVIEW
            </Box>
          </Stack>
          <VideoBlock
            thumbnail="https://img.youtube.com/vi/2LfAYsWeWLo/maxresdefault.jpg"
            youtubeLink={
              "https://www.youtube.com/watch?v=2LfAYsWeWLo&list=PLgBxj8BHl0M33FtRIckAJCR0JEjqz2ujJ&index=2"
            }
          >
            <>
              <Box className="text text-bold video-title" mt={0.75} mb={2}>
                Watch this final video to review the self-management skills we have learned:
              </Box>
            </>
          </VideoBlock>
          <Stack className="whiteBox" mb={"20px"}>
            <Box className="header2 green" mb={"11px"}>
              S.M.A.R.T. principle:
            </Box>
            <Stack direction={"row"} gap={3.5}>
              <Stack>
                <Box className="text text-bold orange" mb={2}>
                  S=Specific
                </Box>
                <Box className="text">
                  Specific Goals that are "do your best goals" are not specific and don't lend
                  themselves to being able to be built upon.
                </Box>
              </Stack>
              <Stack>
                <Box className="text text-bold orange" mb={2}>
                  M=Measurable
                </Box>
                <Box className="text">
                  Measurable In order for something to be measurable we need to have some metrics or
                  values that we're measuring, like walking for 20 minutes, 3 times per week.
                </Box>
              </Stack>
              <Stack>
                <Box className="text text-bold orange" mb={2}>
                  A=Attainable
                </Box>
                <Box className="text">
                  Be sure that your goals are truly doable given your life's variables. Walking for
                  60 minutes 7 days a week is very aggressive and difficult for even the most
                  seasoned exerciser to attain.
                </Box>
              </Stack>
              <Stack>
                <Box className="text text-bold orange" mb={2}>
                  R=Recorded
                </Box>
                <Box className="text">
                  Recorded Be sure that you have a way to record your activity so that trends can be
                  reviewed. An App or paper and pen work great.
                </Box>
              </Stack>
              <Stack>
                <Box className="text text-bold orange" mb={2}>
                  T=Time Based
                </Box>
                <Box className="text">
                  Time Based Be sure that you have a date set when you can assess your goal progress
                  and set new goals.
                </Box>
              </Stack>
            </Stack>
          </Stack>
          <Stack className="whiteBox" mb={"20px"}>
            <Box className="header2" mb={"11px"}>
              Dissociation
            </Box>
            <p>
              Find a few activities that take your mind off of the boredom or discomfort of exercise
            </p>
          </Stack>
          <Stack className="whiteBox" mb={"20px"}>
            <Box className="header2" mb={"11px"}>
              Relapse Prevention - Part 1
            </Box>
            <p>
              Identify barriers that could keep you from being success with your exercise plan and
              identify ways around those barriers.
            </p>
          </Stack>
          <Stack className="whiteBox" mb={"20px"}>
            <Box className="header2" mb={"11px"}>
              Relapse Prevention - Part 2
            </Box>
            <p>
              Recognize feels associated with productive and unproductive events that you may have
              encountered and find creative and flexible ways to accomplish a goal.
            </p>
          </Stack>
          <Stack className="whiteBox" mb={"20px"}>
            <Box className="header2" mb={"11px"}>
              Thought Restructuring
            </Box>
            <p>
              Training oneself to identify the unproductive thoughts that sneak into our mind and
              can derail us if we don't stop the thought and replace it with something more
              productive.
            </p>
          </Stack>
          <Stack className="whiteBox" mb={"20px"}>
            <Box className="header2" mb={"11px"}>
              Exercise Triggers
            </Box>
            <p>What "triggers" you to exercise!?</p>
          </Stack>
          <Stack className="whiteBox" mb={"20px"}>
            <Box className="header2" mb={"11px"}>
              Self-Reward
            </Box>
            <p>How do you reward your self for a goal or a job well-done?</p>
          </Stack>
        </Box>
        <hr className="containerDivider" />
        <Stack direction={"row"} justifyContent="space-around">
          <button type="button" className="action-button" onClick={() => sendContractToBackend()}>
            Email Document to the Member
          </button>
          <ReactToPrint
            trigger={() => (
              <button type="button" className="action-button">
                Print Document
              </button>
            )}
            content={() => printTemplateRef.current}
          />
        </Stack>
      </Box>
      <div className="out-of-sight">
        <Stack ref={printTemplateRef} className="elementToPrint">
          <YmcaPageHeader />
          <Stack direction={"row"} gap={2}>
            <img src={QRcode} width="114" height="114" />
            <Stack>
              <h1 style={{ color: "#00a98f" }}>SELF-MANAGEMENT SKILLS REVIEW</h1>
              <Box>
                <p>Watch this final video to review the self-management skills we have learned:</p>
              </Box>
            </Stack>
          </Stack>
          <Stack>
            <Stack direction={"row"} mt={2} mb={2} gap={1} alignItems="center">
              <h2>Goal Setting</h2>
              <span>-</span>
              <p>
                remember the <span className="orange">S.M.A.R.T.</span> acronym
              </p>
            </Stack>
            <h2 className="orange">S=Specific</h2>
            <Box mb={2}>
              <p>
                Specific Goals that are "do your best goals" are not specific and don't lend
                themselves to being able to be built upon.
              </p>
            </Box>
            <h2 className="orange">M=Measurable</h2>
            <Box mb={2}>
              <p>
                Measurable In order for something to be measurable we need to have some metrics or
                values that we're measuring, like walking for 20 minutes, 3 times per week.
              </p>
            </Box>
            <h2 className="orange">A=Attainable</h2>
            <Box mb={2}>
              <p>
                Be sure that your goals are truly doable given your life's variables. Walking for 60
                minutes 7 days a week is very aggressive and difficult for even the most seasoned
                exerciser to attain.
              </p>
            </Box>
            <h2 className="orange">R=Recorded</h2>
            <Box mb={2}>
              <p>
                Recorded Be sure that you have a way to record your activity so that trends can be
                reviewed. An App or paper and pen work great.
              </p>
            </Box>
            <h2 className="orange">T=Time Based</h2>
            <Box mb={2}>
              <p>
                Time Based Be sure that you have a date set when you can assess your goal progress
                and set new goals.
              </p>
            </Box>
          </Stack>
          <Box mb={1}>
            <p>
              <span className="green">Dissociation</span> &mdash; Find a few activities that take
              your mind off of the boredom or discomfort of exercise
            </p>
          </Box>
          <Box mb={1}>
            <p>
              <span className="green">Relapse Prevention - Part 1</span> &mdash; Identify barriers
              that could keep you from being success with your exercise plan and identify ways
              around those barriers.
            </p>
          </Box>
          <Box mb={1}>
            <p>
              <span className="green">Relapse Prevention - Part 2</span> &mdash; Recognize feels
              associated with productive and unproductive events that you may have encountered and
              find creative and flexible ways to accomplish a goal.
            </p>
          </Box>
          <Box mb={1}>
            <p>
              <span className="green">Thought Restructuring</span> &mdash; Training oneself to
              identify the unproductive thoughts that sneak into our mind and can derail us if we
              don't stop the thought and replace it with something more productive.
            </p>
          </Box>
          <Box mb={1}>
            <p>
              <span className="green">Exercise Triggers</span> &mdash; What "triggers" you to
              exercise!?
            </p>
          </Box>
          <Box>
            <p>
              <span className="green">Self-Reward</span> &mdash; How do you reward your self for a
              goal or a job well-done?
            </p>
          </Box>
        </Stack>
      </div>
    </>
  );
};

export default StageFollowup05;
